import { Select, SelectProps } from 'antd';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Country } from 'src/common/types';

const SelectCountry: FC<SelectProps> = (props) => {
  const { t } = useTranslation();

  return (
    <Select
      {...props}
      allowClear={props.allowClear ?? true}
      style={props.style ?? { width: '100%', height: '100%' }}
      showSearch
      filterOption={(input, option) => ((option?.label as string) ?? '').toLowerCase().includes(input.toLowerCase())}
      options={Object.values(Country)
        .map((country) => ({ value: country, label: t(country) }))
        .sort((a, b) => {
          return a.label.localeCompare(b.label);
        })}
    />
  );
};

export default SelectCountry;
